import GetOrdersInPipelineStage from "../queries/GetOrdersInPipelineStageTemp.pim.js";
export const getOrdersInPipelineStage = async ({ pipelineId, pipelineStageId, customerIdentifier }, { client }) => {
    const data = await client.pim.request(GetOrdersInPipelineStage, {
        tenantId: client.tenantId,
        pipelineId,
        pipelineStageId,
        customerIdentifier,
    });
    return data.order.getMany?.edges?.map((edge) => edge.node) ?? [];
};
